"use client"

import { LayoutDashboard } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LayoutDashboardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LayoutDashboardIcon = component(Icon)({ as: LayoutDashboard })
